import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

import { GradientNumberComponent } from '../gradient-numbers/gradient-number.component';

/**
 * Component providing an aggregation context for Top10 Game Tile
 * The component provides 10 different slots for placing all the constituents
 * making-up the game tile across various breakpoints, aka mobile, desktop, tabs etc.
 * Supported slots are:
 * 1.  gradient
 * 2.  badge
 * 3.  freespinsSummaryIcon
 * 4.  imageLoader
 * 5.  jackpotHotIcon
 * 6.  quickInfoIcon
 * 7.  gametileFavCta
 * 8.  gameTileCta
 * 9.  hyperlinkCta
 * 10. gameTileFooter
 */
@Component({
    selector: 'cs-top10-game-tile-aggregator',
    templateUrl: './tile-aggregation.component.html',
    styleUrl: './tile-aggregation.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, CommonModule, GradientNumberComponent],
})
export class TopTenGameTileAggregationComponent {
    /**
     * The corresponding state of view in which the tile is currently,
     * Supported states are:
     *      1. normal
     *      2. overlay
     *      3. disabled
     * overlay state is also activated during mouseover(using css)
     */
    viewStates = TileViewState;
    viewState = input<TopTenTileViewState>(TileViewState.Normal);
    showonMouseHover = false;
    withOverlay = input<boolean>(true);
    currentViewState = signal<TopTenTileViewState>(this.viewState());
    withFav = input<boolean>(true);
    gradientIndex = input<number>(1);
    imageContainerClass: string;

    mouseenter() {
        if (this.withOverlay() && this.viewState() === TileViewState.Normal) {
            this.currentViewState.set(TileViewState.Overlay);
        }
    }

    mouseleave() {
        if (this.withOverlay()) {
            this.currentViewState.set(this.viewState());
        }
    }
}

export enum TileViewState {
    Normal = 'normal',
    Overlay = 'overlay',
    Disabled = 'disabled',
}

export type TopTenTileViewState = TileViewState;
